import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { hotlineLpSectionFaqStyle } from '@/feature/hotline/lp/component/HotlineLpSectionFaq/style';
import { HotlineLpSpeechBubble } from '@/feature/hotline/lp/component/HotlineLpSpeechBubble';
import { useAccordionDetails } from '@/utils/ui/accordion/useAccordionDetails';
/**
 * ホットライン LP FAQ セクション（項目）
 */
export const HotlineLpSectionFaqItem = (props) => {
    const { className = '', item } = props;
    const detailsRef = useRef(null);
    const contentRef = useRef(null);
    // アコーディオン 開閉制御
    const { onClickSummary } = useAccordionDetails({
        contentRef,
        detailsRef,
    });
    const style = hotlineLpSectionFaqStyle();
    return (_jsx(HotlineLpSpeechBubble, Object.assign({ className: style.item({ class: className }), tagName: 'li', variants: { rounded: 'small' } }, { children: _jsxs("details", Object.assign({ className: style.itemDetails(), ref: detailsRef }, { children: [_jsxs("summary", Object.assign({ className: style.itemSummary(), onClick: onClickSummary }, { children: [_jsxs("span", Object.assign({ className: style.itemQuestionTextWrapper() }, { children: [_jsx("span", Object.assign({ className: style.itemQuestionHeadText() }, { children: "Q" })), _jsx("span", Object.assign({ className: style.itemQuestionText() }, { children: item.q }))] })), _jsx("span", { "aria-label": '開閉', className: style.itemIcon() })] })), _jsx("div", Object.assign({ className: style.itemContentWrapper(), ref: contentRef }, { children: _jsx("span", Object.assign({ className: style.itemContent() }, { children: item.a })) }))] })) })));
};
